import React, { Component } from 'react';

class MainMenu extends Component {

  constructor(props) {
    super(props);
    this.state = {
        hireMeTooltip: "tell me about your project and I'll send you a free quote",
        phoneNumberTooltip: "pick up the phone and let's have a chat"
    };
    this.scrollToSection = this.scrollToSection.bind(this);
  }

  scrollToSection(e) {
    e.preventDefault();
    let sectionId   = e.currentTarget.hash.replace('#', ''),
        section     = document.getElementById(sectionId);
    if (section) {
        section.scrollIntoView({behavior: "smooth", block: "start"});
    }
  }

  render() {
    return (
      <ul>
        <li><a href="#work" onClick={this.scrollToSection}>My Work</a></li>
        <li><a href="#about" onClick={this.scrollToSection}>About Me</a></li>
        <li><a href="#services" onClick={this.scrollToSection}>Services</a></li>
        <li><a href="#clients" onClick={this.scrollToSection}>Clients</a></li>
        <li><a href="tel:+447950930561" alt={this.state.phoneNumberTooltip} title={this.state.phoneNumberTooltip}>+44(0)7950 930 561</a></li>
        <li><a href="#contact" class="btn neon-green-glow" onClick={this.scrollToSection} alt={this.state.hireMeTooltip} title={this.state.hireMeTooltip}>Hire Me</a></li>
      </ul>
    );
  }

}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.js